<template>
  <b-modal no-fade v-model="dialog.show" size="xl"  :id="`modal-brand-${uniqueId}`"
           :hide-footer="true" centered @close="onDialogClose"
           no-close-on-backdrop
  >
    <template #modal-title>
     <span v-if="loading !== true && error == null && brand != null && brand.id != null">
       {{ brand.name }}
     </span>
    </template>
    <div style="min-height: 600px">
      <div v-if="loading !== true && error == null">
        <brand-edit-details v-bind:new-brand="isNewBrand" v-model="brand" @close="closeModal" />
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else-if="loading !== true && error != null">
        <b-alert show variant="danger" >
          <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
          {{ error }}
        </b-alert>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else>
        <b-spinner>{{$t('operations.loading')}}</b-spinner>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import { mapActions } from 'vuex'
import BrandEditDetails from '@/components/partial/brands/BrandEditDetails'
import Brand from '@/model/brand/Brand'

export default {
  name: 'brandModal',
  components: { BrandEditDetails },
  mixins: [mixinBase, mixinNotifications],
  data: () => ({
    dialog: {
      show: false,
    },
    uniqueId: 0,
    loading: true,
    error: null,
    id: null,
    isNewBrand: false,
    brand: {}
  }),
  watch: {
    queryParams:{
      handler(){
        if(this.queryParams().brandId == null) {
          this.closeModal()
          return
        }
        if (this.queryParams().brandId !== this.id) {
          this.showModal(this.queryParams().brandId)
        }
      },
      deep: true
    }
  },
  created() {
    this.uniqueId = this._uid
    if(this.queryParams().brandId != null) {
      this.showModal(this.queryParams().brandId)
    }
  },
  methods: {
    ...mapActions('brand', ['getBrandById']),
    showModal(id) {
      this.id = id
      this.loading = true
      this.dialog.show = true
      this.dialog.tab = 0
      this.isNewBrand = this.id == null || this.id === 0;
      if(!this.isNewBrand) {
        this.refreshData()
      }else {
        this.brand = Brand()
        this.error = null
        this.loading = false
      }
      this.pushState({brandId: id, tab: 0, })
    },
    closeModal(){
      this.dialog.show = false;
      this.brand = {}
      this.onDialogClose()
    },
    onDialogClose(){
      this.id = null;
      this.pushState({brandId: null, tab: null, })
    },
    refreshData() {
      let $this = this;
      this.getBrandById(this.id)
          .then(brand => {
            $this.brand = brand;
            $this.error = null
            $this.loading = false
          }, err => {
            $this.error = $this.getErrorDescription(err)
            $this.loading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
